import { render, staticRenderFns } from "./ProfileCollection.news.vue?vue&type=template&id=76f72682&"
import script from "./ProfileCollection.news.vue?vue&type=script&lang=js&"
export * from "./ProfileCollection.news.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports